module.exports = __webpack_public_path__ + "static/img/pic7.238f310.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case1/pic7.jpg
// module id = xeH1
// module chunks = 1